import logo from "../../assets/logo.png";

import React from "react";

import { FooterLinksLocal } from "./footer.links.local";
import { FooterLinks } from "./footer.links";

export const FooterPC: React.FC<any> = () => {
  return (
    <div className="footer">
      <div className="footer-links-container">
        <img src={logo} className="footer-links-logo" />
        <FooterLinks />
      </div>
      <div></div>
      <FooterLinksLocal />
    </div>
  );
};
